// @flow

export const VOUCHER_DUE_DATE_FORMAT = 'dd/MM';
